export default __webpack_public_path__ + "static/media/attendance.f34499f0.svg";